import { setAuthorizationHeader } from '../../api/commons';
import storage from '../../storage';
import { TOKEN } from '../../constants/cookies';

const requestDecoratorInit = () => {
  const requestDecorator = () => {
    return (next) =>
      (action = {}) => {
        const { type = '' } = action;

        if (type && type.endsWith('_REQUEST')) {
          setAuthorizationHeader(storage.getItem(TOKEN));
        }

        next(action);
      };
  };

  return requestDecorator;
};

export default requestDecoratorInit;
